<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <template v-if="settings && products && products.length">
            <TimelineView v-if="useNewScheduler" :url="dataUrl" :products="products" :mode="mode" :shopId="shopId" :locale="locale" :component="component" :column="column" :apiKey="apiKey" :baseDomain="baseDomain" :reloadEvents="reloadEvents" :skew="true" :keepTimes="true"/>
            <Timeline v-else :url="dataUrl" :products="products" :mode="mode" :shopId="shopId" :locale="locale" :component="component" :column="column" :apiKey="apiKey" :baseDomain="baseDomain" :reloadEvents="reloadEvents" :skew="true" :keepTimes="true"/>
          </template>
          <template v-else-if="settings">
            <h3>{{ _('No products selected') }}</h3>
            <p>{{ _('Please select a maximum of ten products to view in this component.') }}</p>
          </template>
        </div>
      </div>
      <div class="row" v-if="areAddButtonsVisible" style="margin-top: 10px">
        <div class="col-md-12">
          <button class="btn btn-primary" type="button" v-on:click="addProductDialog"><i class="fa fa-fw fa-cubes"></i> {{ _('Add product') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import producttypes from '~/lib/producttypes'
import modals from '~/lib/modals'
import settingshelpers from '~/lib/settingshelpers'
import Timeline from '~/components/Timeline'
import TimelineView from '~/components/TimelineView'

export default {
  data () {
    return {
      theaters: [],
      movies: [],
      currEvent: null,
      isExisting: false,
      shouldDelete: false,
      reloadEvents: ['availabilityUpdate', 'availabilityCacheUpdate', 'componentUpdate', 'reservationUpdate'],
      allProducts: [],
      maxItems: 10
    }
  },
  mixins: [components, producttypes, modals, settingshelpers],
  computed: {
    areAddButtonsVisible () {
      // Override by Sami @11.5.2021
      return false
      /*
      if (!this.products) {
        return true
      }
      return this.products.length < this.maxItems
      */
    },
    useNewScheduler () {
      return this.isFeatureEnabled('scheduler2.0')
    },
    dataUrl () {
      const band = this.useNewScheduler ? '&format=band' : ''
      return this.baseDomain + this.shopId + '/schedule.json?products=' + this.products.join(',') + '&apikey=' + this.apiKey + band + (this.mode === 'hourly' ? '&hourly=true' : '')
    },
    products () {
      if (this.component && this.component.data) {
        const data = JSON.parse(this.component.data)
        if (data.products) {
          return data.products.map(r => r.id)
        }
      }
      return []
    },
    mode () {
      if (this.component && this.component.data) {
        const data = JSON.parse(this.component.data)
        if (data.mode) {
          return data.mode
        }
      }
      return 'daily'
    }
  },
  methods: {
    async saveComponent (data) {
      try {
        let url = this.baseDomain + this.shopId + '/components/' + data.id + '.json?apikey=' + this.apiKey
        await axios.put(url, data)
      } catch (e) {
        console.log(e)
      }
    },
    loadProducts () {
      return new Promise (async (resolve) => {
        let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/allproducts.json?version=' + this.locale + '&all=true&apikey=' + this.apiKey)
        let ret = []
        if (response && response.data) {
          for (var i = 0; i < response.data.length; i++) {
            let d = response.data[i]
            if (parseInt(d.type) > 0) { // Only include reservable products
              ret.push({ id: d.id, name: d.name, shopid: d.shopid, type: d.type, subtype: d.subtype, displayedtype: d.displayedtype })
            }
          }
        }
        this.allProducts = ret
        resolve(ret)
      })
    },
    async addProductDialog () {
      if (!this.allProducts.length) {
        await this.loadProducts()
      }
      if (!this.allProductTypes.length) {
        await this.loadProductTypes()
      }
      const buttons = [
        {
          title: this._('Close'),
          icon: 'close',
          handler: () => {}
        },
        {
          title: this._('OK'),
          class: 'success',
          icon: 'check',
          requiredFields: ['product'],
          handler: (data) => {
            this.addProduct(data.product.value)
          }
        }
      ]
      this.showDialog({
        title: this._('Select a product'),
        width: 800,
        buttons: buttons,
        fields: [
          {
            title: this._('Product'),
            type: 'selectize',
            name: 'product',
            options: this.allProducts.map(p => { return { value: p.id + '-' + p.shopid, name: p.name + (p.shopid !== this.shopId ? ' (' + p.shopid + ')': ''), desc: this.productType(p) }}),
            defaultValue: null
          }
        ]
      })
    },
    addProduct (productStr) {
      if (!this.component) {
        return
      }
      let data
      if (!this.component.data) {
        data = { products: [] }
      } else {
        data = JSON.parse(this.component.data)
      }
      const prodArr = productStr.split('-')
      const prodId = prodArr[0]
      const shopId = prodArr[1]
      const product = this.allProducts.find(p => p.id === prodId && p.shopid === shopId)
      if (!data.products) {
        data.products = []
      }
      data.products.push(product)
      this.component.data = JSON.stringify(data)
      this.saveComponent(this.component)
    }
  },
  components: {
    Timeline,
    TimelineView
  },
  mounted () {
    /*
    if(!this.events) {
      let events = {}
      events['showUpdate'] = (message) => {
        if (message && message.data && message.shopId === this.shopId) {
          return this.reload()
        }
      }
      this.events = events
    }
    this.enableEventBus()
    */
  }
}

</script>
